import { Button, Grid, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useForm, Controller } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import * as yup from "yup";
import { CODES } from "../../consts/codes";
import moment from "moment";
import { useSelector } from "react-redux";
import { getUser } from "../../pages/userSlice";
import {
  ApplyFiltersSalesForce,
  GetFileStatusList,
} from "../../services/user/salesForceServices";
import { GetListUploadesExternalFiles } from "../../services/user/externalFiles/externalFilesService";

export const FilterSalesForce = (props) => {
  /**
   * Skeleton
   */

  const skeletonLine = [
    {
      id: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
      startDate: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
      endDate: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
      user: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
      file: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
      state: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
      errors: <Skeleton variant="text" sx={{ fontSize: "1rem" }} />,
    },
  ];

  const { t } = useTranslation();
  const [statusList, setStatusList] = useState([]);
  const userInfo = useSelector(getUser);
  const handleFilters = async (data, e) => {
    try {
      e.preventDefault();
      props.setFilterNotFound(false);
      props.setIsLoadingData(true);

      props.idFile === 4
        ? props.setData([])
        : props.setData(props.skeletonLine ? props.skeletonLine : skeletonLine);

      const obj =
        props.idFile === 27
          ? {
              eanCompany: userInfo.company.eanCompany,
              country: userInfo.company.country,
              emailLoad: userInfo.email,
              state: data.role ? data.role.label : "",
              documentType: props.documentType,
              typeCompany: userInfo.company.typeCompany,
              idFileType: props.idFile,
            }
          : {
              eanProvider: userInfo.company.eanCompany,
              country: userInfo.company.country,
              emailLoad: userInfo.email,
              state: data.role ? data.role.label : "",

              idFileType: props.idFile,
            };

      const salesForceService =
        props.idFile === 27
          ? await GetListUploadesExternalFiles(obj)
          : await ApplyFiltersSalesForce(obj);
      props.setIsLoadingData(false);
      if (salesForceService.status === CODES.COD_RESPONSE_HTTP_OK) {
        if (
          salesForceService.data.responseCode === 200 ||
          salesForceService.data.responseCode === 0
        ) {
          const responseMessage = salesForceService.data.responseMessage;

          const ProcessRows = responseMessage.map((item, idx) => {
            return {
              id: !item.idLoad ? " - " : item.idLoad,
              startDate:
                item.starDate === null
                  ? " - "
                  : moment(item.starDate).format("YYYY-MM-DD hh:mm"),
              endDate:
                item.endDate === null
                  ? " - "
                  : moment(item.endDate).format("YYYY-MM-DD hh:mm"),
              user: !item.userLoad ? " - " : item.userLoad,
              file: !item.fileName
                ? " - "
                : {
                    fileName: item.fileName,
                    pathFileName: item.pathFileName,
                  },
              state: !item.state ? " - " : item.state,
              errors: item.awsUploadLog
                ? {
                    awsUploadLog: item.awsUploadLog,
                  }
                : {
                    logFileName: item.logFileName,
                    pathLogFileName: item.pathLogFileName,
                    awsUploadLog: item.awsUploadLog,
                  },
            };
          });
          if (ProcessRows.length === 0) {
            props.setFilterNotFound(true);
          }
          props.setFilterApply(data.role);
          props.setData(ProcessRows);
        } else {
          props.setFilterNotFound(true);
          props.setFilterApply(data.role);
          props.setData([]);
        }
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  const schema = yup.object().shape({
    ean: yup.string().min(2),
    country: yup.string().min(2),
  });

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });

  useEffect(() => {
    let mounted = true;

    async function fetchData() {
      try {
        if (mounted) {
          const statusService = await GetFileStatusList();
          if (statusService.status === CODES.COD_RESPONSE_HTTP_OK) {
            if (
              statusService.data.responseCode ===
              CODES.COD_RESPONSE_SUCCESS_REQUEST
            ) {
              const responseMessage = statusService.data.responseMessage;
              const roleList = responseMessage.map((item) => ({
                label: item.name,
                value: item.pk,
              }));
              setStatusList(roleList);
            }
          }
        }
      } catch (error) {
        console.log("====================================");
        console.log(error);
        console.log("====================================");
      }
    }
    fetchData();

    return () => {
      mounted = false;
    };
  }, [props.userInfo]);

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid xs={12} sm={6} md={8} item>
        <form id="filter-sales-form" onSubmit={handleSubmit(handleFilters)}>
          <Grid
            container
            direction="row"
            className="formfilt-container"
            spacing={4}
          >
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item>
                  {" "}
                  <label className="form__label">
                    {" "}
                    {props.state
                      ? t("App.traders.table.state")
                      : t("App.salesForce.status")}
                  </label>
                </Grid>
                <Grid item>
                  <Controller
                    name="role"
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        noOptionsText={t("App.listUsers.noOptions")}
                        className={
                          errors.role
                            ? "select__filters__errors"
                            : "select__filters"
                        }
                        options={statusList}
                        renderInput={(params) => {
                          return (
                            <TextField
                              placeholder={
                                props.state
                                  ? t("App.traders.filter.state")
                                  : t("App.salesForce.status")
                              }
                              {...params}
                              onChange={onChange}
                            />
                          );
                        }}
                        onChange={(event, values, reason) => {
                          onChange(values);
                        }}
                        value={value || null}
                      />
                    )}
                    control={control}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <Grid xs={12} sm={6} md={4} item>
        <Grid
          container
          direction="row"
          className="buttonfilt-container"
          gap={2}
        >
          <Grid item>
            <Button
              startIcon={
                <TuneOutlinedIcon
                  sx={{
                    fontSize: 20,
                    color: "white",
                  }}
                />
              }
              disabled={watch("role") ? false : true}
              disableRipple
              className={
                watch("role") ? "btn__applyFilter" : "btn__applyFilter-disabled"
              }
              type="submit"
              form="filter-sales-form"
            >
              {t("App.userDetail.applyFilters")}
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                setValue("status", 0);
                setValue("role", null);
                props.setData(props.unfilteredData);
                props.setFilterApply(null);
                props.setFilterNotFound(false);
              }}
              disableRipple
              className="btn__deleteFilter"
            >
              {t("App.userDetail.cleanFilters")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
